import CardContainer from "./component/CardContainer";
import Header from "./component/Header";
function App() {
  return (
    <div className="text-center mt-4">
      <Header />
      <CardContainer />
    </div>
  );
}

export default App;
